import { endpoints, REQUEST_METHODS } from '../constants';
import { apiSlice } from '../store';

export const coursesService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCourses: builder.query({
      query: ({ category, page, limit } = {}) => {
        const params = new URLSearchParams();
        if (page) params.set('Page', page);
        if (limit) params.set('Limit', limit);
        if (category) params.set('Category', category);
        const qs = params.toString();
        return {
          url: qs ? `${endpoints.courses.list}?${qs}` : endpoints.courses.list,
          method: REQUEST_METHODS.GET
        };
      }
    }),
    getCourseById: builder.mutation({
      query: (values) => ({
        url: endpoints.courses.course,
        method: REQUEST_METHODS.POST,
        body: values
      })
    }),
    getUserCourses: builder.mutation({
      query: (values) => ({
        url: endpoints.courses.userCourses,
        method: REQUEST_METHODS.POST,
        body: values
      })
    }),
    getMyCourseList: builder.query({
      query: (staffId) => ({
        url: staffId
          ? `${endpoints.courses.myCourseList}?StaffId=${staffId}`
          : endpoints.courses.myCourseList,
        method: REQUEST_METHODS.GET
      })
    }),
    requestCourse: builder.mutation({
      query: (values) => ({
        url: endpoints.courses.request,
        method: REQUEST_METHODS.POST,
        body: values
      }),
      invalidatesTags: ['TrainingRequests']
    }),
    getTrainingRequests: builder.query({
      query: (staffId) => ({
        url: `${endpoints.courses.getRequests}?StaffId=${staffId}`,
        method: REQUEST_METHODS.GET
      }),
      providesTags: ['TrainingRequests']
    }),
    getCourseProgress: builder.mutation({
      query: (values) => ({
        url: endpoints.courses.courseProgress,
        method: REQUEST_METHODS.POST,
        body: values
      })
    }),
    getCourseRequestStatus: builder.query({
      query: (requestRef) => ({
        url: endpoints.courses.requestStatus(requestRef),
        method: REQUEST_METHODS.GET
      })
    }),
    approveCourseRequest: builder.query({
      query: (requestRef) => ({
        url: endpoints.courses.approveRequest(requestRef),
        method: REQUEST_METHODS.GET
      })
    }),
    denyCourseRequest: builder.query({
      query: (requestRef) => ({
        url: endpoints.courses.denyRequest(requestRef),
        method: REQUEST_METHODS.GET
      })
    }),
    getTasks: builder.query({
      query: (staffId) => ({
        url: `${endpoints.tasks.list}?StaffId=${staffId}`,
        method: REQUEST_METHODS.GET
      })
    }),
    getIDPCourses: builder.query({
      query: () => ({
        url: endpoints.courses.idpCourses,
        method: REQUEST_METHODS.GET
      })
    }),
    getPendingCourses: builder.query({
      query: (staffId) => ({
        url: `${endpoints.courses.pendingCourses}?StaffId=${staffId}`,
        method: REQUEST_METHODS.GET
      })
    }),
    getOverdueCourses: builder.query({
      query: (staffId) => ({
        url: `${endpoints.courses.overdueCourses}?StaffId=${staffId}`,
        method: REQUEST_METHODS.GET
      })
    })
  })
});

export const {
  useGetCoursesQuery,
  useLazyGetCoursesQuery,
  useGetCourseByIdMutation,
  useGetUserCoursesMutation,
  useGetMyCourseListQuery,
  useLazyGetMyCourseListQuery,
  useRequestCourseMutation,
  useGetTrainingRequestsQuery,
  useLazyGetTrainingRequestsQuery,
  useGetCourseProgressMutation,
  useGetCourseRequestStatusQuery,
  useLazyGetCourseRequestStatusQuery,
  useApproveCourseRequestQuery,
  useLazyApproveCourseRequestQuery,
  useDenyCourseRequestQuery,
  useLazyDenyCourseRequestQuery,
  useGetTasksQuery,
  useLazyGetTasksQuery,
  useGetIDPCoursesQuery,
  useLazyGetIDPCoursesQuery,
  useGetPendingCoursesQuery,
  useLazyGetPendingCoursesQuery,
  useGetOverdueCoursesQuery,
  useLazyGetOverdueCoursesQuery
} = coursesService;
